<style src="./MultiSelect.scss" lang="scss"></style>

<template lang="pug">
  .multi-select(
    :style=`{
      "min-width": selected.length ? null : "calc(" + placeholder.length + "ch + 66px)"
    }`
  )
    v-select(
      multiple
      @input='onInput'
      v-model='selected'
      :label="label" 
      :searchable='false'
      :options='filtredOptions'
      :placeholder='placeholder'
      :components='{ OpenIndicator, Deselect }'
    )
      template(
        v-slot:no-options
      )
        p {{ $l10n("NOT_FOUNDED") }}
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  props: ["options", "placeholder", "value", "label"],
  data() {
    return {
      selected: this.value,
      OpenIndicator: {
        render: createElement =>
          createElement("span", {}, [
            createElement(
              "svg",
              {
                class: { icon: true },
                attrs: { viewBox: "0 0 9 15" }
              },
              [
                createElement("path", {
                  attrs: {
                    d: "M1 1L7.5 7.5L1 14",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }
                })
              ]
            )
          ])
      },
      Deselect: {
        render: createElement =>
          createElement(
            "svg",
            {
              class: { icon: true },
              attrs: { viewBox: "0 0 10 10" }
            },
            [
              createElement("path", {
                attrs: {
                  d:
                    "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z",
                  fill: "currentColor",
                  stroke: "none"
                }
              })
            ]
          )
      }
    };
  },
  components: {
    vSelect
  },
  watch: {
    value(value) {
      this.selected = value;
    }
  },
  computed: {
    filtredOptions() {
      return this.options.filter(option => {
        return !this.selected.map(i => i.id).includes(option.id);
      });
    }
  },
  methods: {
    onInput() {
      this.$emit("input", this.selected);
    }
  }
};
</script>
